export enum SupplyBulkActionImportType {
    SupplierProductUpdate = "SUPPLIER_PRODUCT_UPDATE",
    SupplierVariantUpdate = "SUPPLIER_VARIANT_UPDATE",
}
